import { ACCOUNT_TYPE } from "../utils/constants"

export const sidebarLinks = [
  {
    id: 1,
    name: "My Profile",
    path: "/dashboard/my-profile",
    icon: "VscAccount",
  },
  {
    id: 2,
    name: "Dashboard",
    path: "/dashboard/instructor",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscDashboard",
  },
  {
    id: 3,
    name: "My Courses",
    path: "/dashboard/my-courses",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscVm",
  },
  {
    id: 4,
    name: "Add Course",
    path: "/dashboard/add-course",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscAdd",
  },
  {
    id: 5,
    name: "Enrolled Courses",
    path: "/dashboard/enrolled-courses",
    type: ACCOUNT_TYPE.STUDENT,
    icon: "VscMortarBoard",
  },
  {
    id: 7,
    name: "Cart",
    path: "/dashboard/cart",
    type: ACCOUNT_TYPE.STUDENT,
    icon: "VscArchive",
  },
  // {
  //   id: 8,
  //   name: "Services",
  //   path: "/dashboard/admin-services",
  //   type: ACCOUNT_TYPE.ADMIN,
  //   icon: "VscArchive",
  // },
  {
    id: 9,
     name: "Courses",
    path: "/dashboard/admin-categories",
    type: ACCOUNT_TYPE.ADMIN,
     icon: "VscHistory",
  },
   {
    id: 10,
    name: "My Notes",
    path: "/dashboard/my-notes",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscVm",
  },
  {
    id: 11,
    name: "Add Notes",
    path: "/dashboard/add-Notes",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscAdd",
  },
  {
    id: 12,
     name: "Notes",
    path: "/dashboard/admin-Notescategories",
    type: ACCOUNT_TYPE.ADMIN,
     icon: "VscVm",
  },
   {
    id: 13,
     name: "Reviews",
    path: "/dashboard/admin/reviews",
    type: ACCOUNT_TYPE.ADMIN,
     icon: "VscComment",
  },
]
